import { useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';

import { walletSignOut } from '../actions/wallet.action';
import { clearBalanceCache } from '../hooks/useBalanceState';

export const useSignout = (): (() => Promise<void>) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const signOut = async () => {
    queryClient.clear();
    clearBalanceCache();
    dispatch(walletSignOut());
  };

  return signOut;
};
